import { Navigate, Route, Routes, Link, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from './auth/store.js';
import { LoginPage } from './pages/Login.js';
import { AcceptInvitePage } from './pages/AcceptInvite.js';
import { SharedChapterPage } from './pages/SharedChapter.js';
import { ProjectsPage } from './pages/Projects.js';
import { ProjectDetailPage } from './pages/ProjectDetail.js';
import { AccountPage } from './pages/Account.js';
import { ChapterRunnerPage } from './pages/ChapterRunner.js';

export function App() {
  const { user, logout } = useAuth();
  const { t, i18n } = useTranslation();
  const nav = useNavigate();
  const location = useLocation();

  // Reachable without an existing session — this IS how one gets created.
  if (location.pathname.startsWith('/accept-invite/')) {
    return (
      <Routes>
        <Route path="/accept-invite/:token" element={<AcceptInvitePage />} />
      </Routes>
    );
  }

  // Also reachable without a session — a share link decides for itself,
  // per-token, whether it needs a login (see SharedChapterPage).
  if (location.pathname.startsWith('/s/')) {
    return (
      <Routes>
        <Route path="/s/:token" element={<SharedChapterPage />} />
      </Routes>
    );
  }

  if (!user) return <LoginPage />;

  // Runner gets full viewport — no topbar/shell around it.
  const isRunner = location.pathname.startsWith('/run/');

  if (isRunner) {
    return (
      <Routes>
        <Route path="/run/:chapterId/:mode" element={<ChapterRunnerPage />} />
      </Routes>
    );
  }

  return (
    <div className="app">
      <header className="topbar">
        <div style={{ display: 'flex', gap: 24, alignItems: 'center' }}>
          <h1>
            <Link to="/" style={{ color: 'inherit', textDecoration: 'none' }}>
              {t('app.title')}
            </Link>
          </h1>
        </div>
        <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
          <select
            value={i18n.language.split('-')[0]}
            onChange={(e) => void i18n.changeLanguage(e.target.value)}
            style={{ width: 80 }}
          >
            <option value="nl">NL</option>
            <option value="en">EN</option>
          </select>
          <Link to="/account" className="muted">
            {user.displayName}
          </Link>
          <button
            className="secondary"
            onClick={() => { logout(); nav('/'); }}
          >
            {t('auth.logout')}
          </button>
        </div>
      </header>
      <main className="main">
        <Routes>
          <Route path="/" element={<ProjectsPage />} />
          <Route path="/account" element={<AccountPage />} />
          <Route path="/projects/:projectId" element={<ProjectDetailPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
}
